import { Container } from 'metrix-common3';
import { useEffect } from 'react';
import BoundedFooter from './Footer';
import BoundedHeader from './Header';
import BoundedResults from './Results';

const Bound = (props) => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: only re-run on listed deps
    useEffect(() => {
        props.doReduceView('bound');
        if (props.query.bound.search) {
            props.doQueryBoundPolicies();
        } else {
            props.doGetBoundPolicies();
        }
    }, [props.query.bound.search]);

    return (
        <Container>
            <BoundedHeader {...props} />
            <BoundedResults {...props} />
            <BoundedFooter {...props} />
        </Container>
    );
};

export default Bound;
